<p>snitem-table-row-icons works!</p>
